import { FireIcon } from './FireIcon';

/**
 * author: Google
 * id 5259DBA5-B2FB-4112-B1F2-5DC17002205C
 * name fire
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/fire.svg
 * tags
 * - Home Automation 
 */
export const WhatshotIcon = FireIcon;
export default WhatshotIcon